import React from 'react';
import { translationStatusDescriptions } from '../utils/apiDefinitions';

const StatusDescriptionsSection = () => {
  return (
    <div>
      <div className="rounded-md overflow-hidden">
        {Object.entries(translationStatusDescriptions).map(([status, description], index) => (
          <div 
            key={status} 
            className={`px-1 py-3 ${index !== 0 ? 'border-t border-[--gray-4]' : ''}`}
          >
            <div className="flex items-center mb-1">
              <span className="font-mono text-[14px] font-medium text-[--gray-12]">
                {status}
              </span>
            </div>
            <p className="text-sm text-[--gray-11]">{description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusDescriptionsSection; 